import { motion } from "framer-motion";
import { Eyebrow } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Death to boring wall clocks",
    body: "The beige circle with twelve polite numbers had a good run. It's over. We curate timepieces that drip, bend, hover and generally refuse to behave.",
  },
  {
    n: "02",
    title: "Time as emotional sculpture",
    body: "A clock is the most-looked-at object in your home. It should make you feel something — delight, confusion, a small grin at 3am. Ours do.",
  },
  {
    n: "03",
    title: "Function wrapped in anarchy",
    body: "Every piece still works beautifully. It tells time, holds your wine, lights your room. It just does it with an attitude problem.",
  },
];

export default function ManifestoChapters() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative bg-obsidian py-24 sm:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Eyebrow>The Weird O'Clock manifesto</Eyebrow>
        <div className="mt-4 space-y-0">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              data-testid={`manifesto-chapter-${c.n}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              className="group grid grid-cols-12 items-baseline gap-4 border-t border-white/10 py-10 transition-colors duration-500 hover:border-amber/40 sm:py-14"
            >
              <span className="col-span-3 font-mono2 text-sm text-amber sm:col-span-2 sm:text-base">
                /{c.n}
              </span>
              <h3 className="col-span-9 font-display text-xl font-extrabold tracking-tight text-ivory transition-transform duration-500 group-hover:translate-x-2 sm:col-span-5 sm:text-2xl lg:text-4xl">
                {c.title}
              </h3>
              <p className="col-span-9 col-start-4 mt-2 max-w-md text-sm leading-relaxed text-ivory/50 sm:col-span-5 sm:col-start-8 sm:mt-0 sm:text-base">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
        <div className="border-t border-white/10" />
      </div>
    </section>
  );
}
